import React from 'react';
import { Prospect } from '../../shared/types';

interface FooterSectionProps {
  prospect: Prospect;
}

export const FooterSection: React.FC<FooterSectionProps> = ({ prospect }) => {
  return (
    <footer className="py-8 border-t border-slate-200 bg-white text-slate-500 text-xs">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4">
        <div>
          <span className="font-extrabold text-slate-900 text-sm tracking-tight">YOUMACHINE</span>
          <span className="ml-2 text-slate-500">• Plataforma de Propostas Comerciais Inteligentes</span>
        </div>

        <div className="text-center md:text-right text-slate-500">
          Proposta elaborada para {prospect.name} ({prospect.city}/{prospect.state}) • Todos os direitos reservados © {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
};
